import React from "react";

const ArrowAnimation = ({}) => {
  return (
    <div className="arrow">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
export default ArrowAnimation;
